<template>
  <v-card v-ripple flat class="home-tile">
    <div class="d-flex align-center">
      <v-icon class="home-tile__icon">{{ icon }}</v-icon>
      <div class="v-card-h2">{{ title }}</div>
    </div>

    <div class="v-card-h4 home-tile__description">{{ text }}</div>
  </v-card>
</template>

<script>
// @vuese
// Kafelka
// @group base
export default {
  props: {
    // Tytuł
    title: {
      type: String,
      default: ''
    },
    // Tekst
    text: {
      type: String,
      default: ''
    },
    // Ikona
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>
